// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"0e00a910","322":"f7556988","617":"dbc675d9","787":"f22ea82f"}[chunkId] + ".chunk.js";
};